// Centralized brand constants — single source of truth for URLs, email,
// and display names. Swap here when the final domain lands.

export const BRAND = {
  siteUrl: "https://niggunim.net",
  contactEmail: "contact@niggunim.net",
  displayName: "ניגונים",
  displayNameLatin: "Niggunim",
} as const;
